import request from '@/utils/request'

//  通过服务项目ID-查询服务商排班列表
export const detailServiceProviderSchedule = (id, formData) => {
    return request.get(`/serviceProviderSchedule/serviceItem/${id}`, {params: formData})
}


//  新增服务商排班
export const addServiceProviderSchedule = (formData) => {
    return request.post('/serviceProviderSchedule', formData)
}

//  修改服务商排班
export const editServiceLocation = (providerScheduleId, updateData) => {
    return request.put(`/serviceProviderSchedule/${providerScheduleId}`, updateData)
}

//  获取服务项目可预约日期列表
export const lisServiceProviderAvailableDates = (serviceItemId) => {
    return request.get(`/serviceProviderSchedule/calendar/available-dates?serviceItemId=${serviceItemId}`)
}

//  查询可预约的排班
export const lisServiceProviderAvailableByServiceItemId = (serviceItemId, formData) => {
    return request.get(`/serviceProviderSchedule/calendar/${serviceItemId}/available`, {params: formData})
}

//  删除服务商排班
export const deleteServiceProviderSchedule = (providerScheduleId) => {
    return request.delete(`/serviceProviderSchedule/${providerScheduleId}`)
}
